import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip
} from 'chart.js';
import { prefersReducedMotion } from './useReveal';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

export const CHART_COLORS = {
    deep: '#081f5c',
    channel: '#334eac',
    gutter: '#7096d1',
    surface: '#f9fcff',
    soft: '#4a5b8a'
};

export const CHART_FONT = { family: "'Barlow', 'Helvetica Neue', Arial, sans-serif", size: 14 };

export function chartAnimation() {
    return prefersReducedMotion() ? false : { duration: 1100, easing: 'easeOutBack' };
}

// 1:23.4 style label for a seconds axis.
export function secondsToLabel(seconds, decimals = 0) {
    const min = Math.floor(seconds / 60);
    const rest = seconds - min * 60;
    if (min === 0) return rest.toFixed(decimals);
    const text = rest.toFixed(decimals).padStart(decimals ? decimals + 3 : 2, '0');
    return `${min}:${text}`;
}
